/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-get, ember/no-observers, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import EmberObject, { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import SchoolStatus from '@linc-technologies/linced-common/enums/school-status';
import { observes } from '@ember-decorators/object';

export default class AttendanceController extends Controller {
  // Services
  @service
  dates;

  @service
  permissions;

  @service
  session;

  @service
  store;

  @service
  terms;

  SchoolStatus = SchoolStatus;
  @tracked
  marked = EmberObject.create(); // Map of dates / periods which have been marked.
  @tracked
  takingAttendance = false;
  @tracked
  attendanceDate = null;
  @tracked
  attendancePeriod = null;
  term = null;

  @observes('term', 'model.id')
  _updateMarked() {
    this.updateMarked();
  }

  @computed('session.scopes.[]')
  get isAdmin() {
    return this.permissions.meet('urn:linced:organisation:role:admin');
  }

  init() {
    super.init(...arguments);
    this.set('term', this.terms.currentOrNextTerm);
  }

  @action
  markAttendance(date, period) {
    this.attendanceDate = date;
    this.attendancePeriod = period;
    this.takingAttendance = true;
  }

  @action
  closeAttendance(saved) {
    if (saved) {
      // Preemptively flag it as marked.
      this.setMarked(this.attendanceDate.date, this.attendancePeriod.id);
      if (this.isAdmin) {
        // Check whether we actually have a Register; it may have been deleted
        // via the (admin-only) bulk clear process.
        let params = {
          // Actual filter params for the query.
          schoolId: this.get('session.activeSchool'),
          groupId: this.get('model.id'),
          dateId: this.attendanceDate.id,
          periodId: this.attendancePeriod.id,
          // Needed for the `setMarked` call - added here as a "snapshot" to
          // prevent weirdness if the user clicks another date before the
          // promise resolves.
          date: this.attendanceDate.date,
        };
        this.store.query('attendance/register', params).then((registers) => {
          this.setMarked(params.date, params.periodId, !isEmpty(registers));
        });
      }
    }
    this.takingAttendance = false;
  }

  setMarked(date, periodId, isMarked) {
    let marked = this.marked;
    if (isEmpty(marked.get(date))) {
      marked.set(date, {});
    }
    marked.set(date + '.' + periodId, isMarked);
  }

  updateMarked() {
    let schoolId = this.get('session.activeSchool');
    let groupId = this.get('model.id');

    this.marked = EmberObject.create();

    // Only run if we have a group ID (model has been loaded) and a term.
    if (groupId && !isEmpty(this.term)) {
      let dateFrom = this.get('term.start');
      let dateTo = this.get('term.end');
      this.store
        .query('attendance/register', { schoolId, groupId, dateFrom, dateTo })
        .then((registers) => {
          registers.forEach((register) => {
            this.setMarked(
              register.get('date'),
              register.get('period.id'),
              true,
            );
          });
        });
    }
  }
}
